var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanEnach(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#EFF5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75422 13.0075C6.75422 12.8175 6.82422 12.6275 6.97422 12.4775L11.9842 7.4675C12.2742 7.1775 12.7542 7.1775 13.0442 7.4675C13.3342 7.7575 13.3342 8.2375 13.0442 8.5275L8.03422 13.5375C7.74422 13.8275 7.26422 13.8275 6.97422 13.5375C6.83422 13.3875 6.75422 13.1975 6.75422 13.0075Z",
    fill: "#23262F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75781 13.0078C6.75781 12.5978 7.09781 12.2578 7.50781 12.2578L24.5078 12.2578C24.9178 12.2578 25.2578 12.5978 25.2578 13.0078C25.2578 13.4178 24.9178 13.7578 24.5078 13.7578L7.50781 13.7578C7.09781 13.7578 6.75781 13.4178 6.75781 13.0078Z",
    fill: "#23262F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7425 24.0075C18.7425 23.8175 18.8125 23.6275 18.9625 23.4775L23.9725 18.4675C24.2625 18.1775 24.7425 18.1775 25.0325 18.4675C25.3225 18.7575 25.3225 19.2375 25.0325 19.5275L20.0225 24.5375C19.7325 24.8275 19.2525 24.8275 18.9625 24.5375C18.8125 24.3875 18.7425 24.1975 18.7425 24.0075Z",
    fill: "#23262F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75781 18.9844C6.75781 18.5744 7.09781 18.2344 7.50781 18.2344L24.5078 18.2344C24.9178 18.2344 25.2578 18.5744 25.2578 18.9844C25.2578 19.3944 24.9178 19.7344 24.5078 19.7344L7.50781 19.7344C7.09781 19.7344 6.75781 19.4044 6.75781 18.9844Z",
    fill: "#23262F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanEnach);
export default __webpack_public_path__ + "static/media/ban-enach.8dfb9b3fa4c3c05c93a19b4809312232.svg";
export { ForwardRef as ReactComponent };